import moment from "moment";
import React from "react";

import { AsyncPaginate } from "react-select-async-paginate";
import LocalStorage from "../../../shared/localStorage";

const CommunityPharmacyDispensingNotificationForm = ({
  registerPatient,
  pharmacies,
  handleChangeSelect,
}) => {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  return (
    <React.Fragment>
      <h1 className="select-category-txt">
        Community Pharmacy Dispensing Notification Form
      </h1>

      <hr className="green-hr" />

      <div className="min-height">
        <div className="dove-gray font-size-16 m-top-3 m-bot-3">
          This notification will advise the nominated community pharmacy that
          they will soon be receiving a High Tech Prescription for lenalidomide
          for your patient. This will enable the community pharmacy to register
          with the patientsafetyhub.ie and enable them to order and dispense
          lenalidomide for your patient.
        </div>

        <h2 className="title-details">
          Email Notification to Nominated Pharmacy*
        </h2>

        <div className="container">
          <div className="row">
            <div className="col">
              <label>Please select the nominated pharmacy*:</label>
              <AsyncPaginate
                debounceTimeout={300}
                loadOptions={pharmacies}
                onChange={(selectedOption) => {
                  handleChangeSelect(selectedOption, "pharmacy_id");
                }}
                className="optimization-dropdown select-border optimization-dropdown-align-fix"
                value={registerPatient?.pharmacy_id}
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <label className="silver">Pharmacy Email Address:</label>
              <input
                type="text"
                name="pharmacy_email_address"
                value={registerPatient?.pharmacy_id?.email || ""}
                className="silver"
                disabled
              />
            </div>
            <div className="col"></div>
          </div>
        </div>

        <h2 className="title-details silver">Physician Details</h2>

        <div className="container">
          <div className="row">
            <div className="col">
              <label className="silver">Name:</label>
              <input
                type="text"
                name="name"
                value={
                  parseLocalStorage?.full_name ||
                  parseLocalStorage?.first_name +
                    " " +
                    parseLocalStorage?.last_name
                }
                className="silver"
                disabled
              />
            </div>
            <div className="col">
              <label className="silver">High Tech Prescription Date:</label>
              <input
                type="text"
                name="high_tech_prescription_date"
                value={moment(
                  registerPatient.high_tech_prescription_date
                ).format("DD / MM / YYYY")}
                className="silver"
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label className="silver">Email Address:</label>
              <input
                type="text"
                name="email_address"
                value={parseLocalStorage?.email}
                className="silver"
                disabled
              />
            </div>
            <div className="col">
              <label className="silver">Hospital Name:</label>
              <input
                type="text"
                name="hospital_name"
                value={parseLocalStorage?.hospital?.name}
                className="silver"
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label className="silver">Hospital Address:</label>
              <input
                type="text"
                name="hospital_address"
                value={parseLocalStorage?.hospital?.address?.full_address}
                className="silver"
                disabled
              />
            </div>
            <div className="col"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default CommunityPharmacyDispensingNotificationForm;
